import React from 'react';
import PropTypes from 'prop-types';
import { OptionsWrapper, Checkbox } from './MultiSelect.style';

const Options = (props) => {

    const {
        list,
        type,
        selected,
        onChange,
        onKeyDown,
        columnCount,
    } = props;

    return (
        <OptionsWrapper columnCount={columnCount}>
            {list.map(opt => (
                <Checkbox
                    key={`${opt.fieldId}_${opt.value}`}
                    label={opt.label}
                    value={opt.value}
                    checked={selected.some(element => element.value.toString() === opt.value.toString() && element.fieldId === opt.fieldId)}
                    handlers={{
                        onChange,
                        onKeyDown,
                    }}
                    type={type}
                    dataAttr={{
                        'data-field-id': opt.fieldId,
                    }}
                />
            ))}
        </OptionsWrapper>
    );

};

Options.propTypes = {
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    columnCount: PropTypes.number,
    list: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
};

export default Options;
